import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

export const initialPaymentLocalState = {
  invoice_number: "",
  payment_type: "",
  payment_method_id: null,
  payment_method: "",
  amount: "",
  pay_date: "",
  note: "",
};
export const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    newPaymentLocal: { ...initialPaymentLocalState },
    payments: [],
    paymentPaginations: {},
    isAddPaymentResponse: false,
    isUpdatePaymentResponse: false,
    paymentDetails: null,
    isFileDownloaded: false,
    isPaymentDeletedResponse: false,
    // pay confirmation state
    payConfirmations: [],
    payConfirmationPaginations: {},
    isAddPayConfirmationResponse: false,
  },

  reducers: {
    getAllPaymentListAction: (state, { payload }) => {},
    setAllPaymentListAction: (state, { payload }) => {
      console.log("payload", payload);
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.payments = list;
      state.paymentPaginations = pagination;
    },

    addPaymentAction: (state, { payload }) => {},
    setAddPaymentResponse: (state, { payload }) => {
      state.isAddPaymentResponse = payload;
    },

    setNewPaymentLocal: (state, action) => {
      state.newPaymentLocal = {
        ...state.newPaymentLocal,
        ...action.payload,
      };
    },

    paymentDeletedAction: (state, { payload }) => {},
    setPaymentDeletedResponse: (state, { payload }) => {
      state.isPaymentDeletedResponse = payload;
    },

    // pay confirmation reducers can be added here
    getPayConfirmationListAction: (state, { payload }) => {},
    setPayConfirmationListAction: (state, { payload }) => {
      console.log("payload", payload);
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.payConfirmations = payload;
      // state.payConfirmationPaginations = pagination;
    },

    addPayConfirmationAction: (state, { payload }) => {},
    setAddPayConfirmationResponse: (state, { payload }) => {
      state.isAddPayConfirmationResponse = payload;
    },
  },
});

const {
  getAllPaymentListAction,
  setAllPaymentListAction,
  addPaymentAction,
  setAddPaymentResponse,
  setNewPaymentLocal,
  paymentDeletedAction,
  setPaymentDeletedResponse,
  getPayConfirmationListAction,
  setPayConfirmationListAction,
  addPayConfirmationAction,
  setAddPayConfirmationResponse,
} = paymentSlice.actions;
export {
  getAllPaymentListAction,
  setAllPaymentListAction,
  addPaymentAction,
  setAddPaymentResponse,
  setNewPaymentLocal,
  paymentDeletedAction,
  setPaymentDeletedResponse,
  getPayConfirmationListAction,
  setPayConfirmationListAction,
  addPayConfirmationAction,
  setAddPayConfirmationResponse,
};

export default paymentSlice.reducer;
